import PageTitle from '../components/PageTitle'
import SubTitle from '../components/SubTitle'
import SEO from '../components/SEO'
import artists from '../data/artistsData.json'

export default function Artist() {
  const subtitleItems = [
    { label: '섭외 문의', value: 'management@cpent.com' }
  ]
  
  return (
    <main className="bg-white">
      <SEO 
        title="아티스트"
        description="씨피엔터테인먼트 소속 아티스트를 소개합니다. 신동엽, 이수지, 지예은, 김규원 등 다양한 아티스트들이 SNL 코리아, 직장인들 등에서 활동하고 있습니다."
        path="/artist"
        keywords="cpent 아티스트, 씨피엔터테인먼트 소속, 신동엽, 이수지, 지예은, 김규원, SNL 코리아 출연진, 직장인들 출연진, 쿠팡플레이 예능, cpentertainment artist"
        image="/images/artist/artist1.png"
      />
      {/* Page Title */}
      <PageTitle title="Artist" />
      
      {/* SubTitle */}
      <SubTitle items={subtitleItems} />
      
      {/* Artists List */}
      <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-20 pt-0 md:pb-[120px]">
        <div className="max-w-[1216px] mx-auto flex flex-col gap-10 md:gap-8">
          {artists.map((artist) => (
            <article key={artist.id} className="flex flex-col md:flex-row gap-4 md:gap-10" itemScope itemType="https://schema.org/Person">
              {/* Artist Image */}
              <figure className="w-full md:w-[700px] aspect-[328/185] md:aspect-[700/394] flex-shrink-0">
                <img 
                  src={artist.image} 
                  alt={`${artist.nameKo} 프로필 사진`}
                  className="w-full h-full object-cover"
                  style={artist.imagePosition ? { objectPosition: artist.imagePosition } : undefined}
                  itemProp="image"
                />
              </figure>
              
              {/* Artist Info */}
              <div className="flex flex-col flex-1 md:justify-end">
                {/* Name and Social Links Row (Mobile) / Name Section (Desktop) */}
                <div className="flex justify-between items-start">
                  <header className="flex flex-col flex-1">
                    <h3 
                      className="text-2xl"
                      style={{
                        color: '#000000',
                        fontFamily: 'Pretendard',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '120%',
                        letterSpacing: '0px'
                      }}
                      itemProp="name"
                    >
                      {artist.nameKo}
                    </h3>
                    <p 
                      className="text-xs md:text-base md:mt-[2px]"
                      style={{
                        color: 'rgba(0, 0, 0, 0.55)',
                        fontFamily: 'Pretendard',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '160%',
                        letterSpacing: '0px',
                        textTransform: 'uppercase'
                      }}
                      itemProp="alternateName"
                    >
                      {artist.nameEn}
                    </p>
                  </header>
                  
                  {/* Social Links - Mobile: top right, Desktop: below career */}
                  {artist.social && (
                    <div className="flex gap-2 md:hidden">
                      {artist.social.instagram && (
                        <a 
                          href={artist.social.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-10 h-10 bg-black rounded-full flex items-center justify-center hover:opacity-80 transition-opacity flex-shrink-0"
                        >
                          <img 
                            src="/images/artist/instagram.svg" 
                            alt="Instagram"
                            className="w-6 h-6"
                          />
                        </a>
                      )}
                      {artist.social.youtube && (
                        <a 
                          href={artist.social.youtube}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-10 h-10 bg-black rounded-full flex items-center justify-center hover:opacity-80 transition-opacity flex-shrink-0"
                        >
                          <img 
                            src="/images/artist/youtube.svg" 
                            alt="YouTube"
                            className="w-6 h-6"
                          />
                        </a>
                      )}
                    </div>
                  )}
                </div>
                
                {/* Career Section */}
                <ul className="flex flex-col mt-2">
                  {artist.career.map((item, index) => (
                    <li 
                      key={index}
                      className="text-sm md:text-sm"
                      style={{
                        color: '#000000',
                        fontFamily: 'Pretendard',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '140%',
                        letterSpacing: '-0.21px'
                      }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
                
                {/* Social Links - Desktop only */}
                {artist.social && (
                  <div className="hidden md:flex gap-4 mt-4">
                    {artist.social.instagram && (
                      <a 
                        href={artist.social.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-[52px] h-[52px] bg-black rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      >
                        <img 
                          src="/images/artist/instagram.svg" 
                          alt="Instagram"
                          className="w-8 h-8"
                        />
                      </a>
                    )}
                    {artist.social.youtube && (
                      <a 
                        href={artist.social.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-[52px] h-[52px] bg-black rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      >
                        <img 
                          src="/images/artist/youtube.svg" 
                          alt="YouTube"
                          className="w-8 h-8"
                        />
                      </a>
                    )}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  )
}
